/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { JourneySegmentBody } from './JourneySegmentBody';
import {
    JourneySegmentBodyFromJSON,
    JourneySegmentBodyFromJSONTyped,
    JourneySegmentBodyToJSON,
    JourneySegmentBodyToJSONTyped,
} from './JourneySegmentBody';

/**
 * 
 * @export
 * @interface JourneyBody
 */
export interface JourneyBody {
    /**
     * 
     * @type {string}
     * @memberof JourneyBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JourneyBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof JourneyBody
     */
    track?: string;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof JourneyBody
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * 
     * @type {Array<JourneySegmentBody>}
     * @memberof JourneyBody
     */
    segments?: Array<JourneySegmentBody>;
    /**
     * 
     * @type {boolean}
     * @memberof JourneyBody
     */
    isActive?: boolean;
    /**
     * Epoch ms this journey goes live. Unset = live as soon as it is active.
     * @type {number}
     * @memberof JourneyBody
     */
    startAt?: number;
    /**
     * Epoch ms this journey stops being live. Unset = never expires.
     * @type {number}
     * @memberof JourneyBody
     */
    endAt?: number;
    /**
     * Tiebreak when several journeys are live at once on the same surface and track — higher wins.
     * @type {number}
     * @memberof JourneyBody
     */
    priority?: number;
}

/**
 * Check if a given object implements the JourneyBody interface.
 */
export function instanceOfJourneyBody(value: object): value is JourneyBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function JourneyBodyFromJSON(json: any): JourneyBody {
    return JourneyBodyFromJSONTyped(json, false);
}

export function JourneyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'track': json['track'] == null ? undefined : json['track'],
        'displayedOn': json['displayedOn'] == null ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(JourneySegmentBodyFromJSON)),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function JourneyBodyToJSON(json: any): JourneyBody {
    return JourneyBodyToJSONTyped(json, false);
}

export function JourneyBodyToJSONTyped(value?: JourneyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'track': value['track'],
        'displayedOn': value['displayedOn'] == null ? undefined : ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(JourneySegmentBodyToJSON)),
        'isActive': value['isActive'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'priority': value['priority'],
    };
}

